/**
 * Module dependencies.
 */

import { Button } from 'app/components/atoms/button/button';
import React from 'react';
import { Actions, FormContent, Wrapper } from './header-search.styles';
import { Combobox } from 'app/components/ui/combobox';
import { Provider } from 'app/hooks/requests/apps-crypto/use-get-apps-crypto-overview';

/**
 * `Filters` type.
 */

export type Filters = {
  coins: string[];
  providers: number[];
  search: string | null;
};

/**
 * `Props` type.
 */

type Props = {
  coinsList: string[];
  providersList: Provider[];
  filters: Filters;
  setFilters: (filters: Filters) => void;
  refetch: () => void;
  fixAmounts: () => void;
};

/**
 * Export `HeaderSearch` component.
 */

export function HeaderSearch(props: Props): JSX.Element {
  const { fixAmounts, coinsList, providersList, refetch, setFilters, filters } = props;

  return (
    <Wrapper>
      <FormContent>
        <div className={'flex min-w-[200px] flex-col gap-1'}>
          <span className={'text-sm font-medium text-foreground'}>{'Coin'}</span>

          <Combobox
            allowClear
            multiple
            onChange={value => {
              setFilters({
                ...filters,
                coins: value as string[]
              });
            }}
            options={(coinsList ?? []).map(item => ({
              value: item,
              label: item
            }))}
            placeholder={'All'}
            value={filters.coins || []}
          />
        </div>

        <div className={'flex min-w-[200px] flex-col gap-1'}>
          <span className={'text-sm font-medium text-foreground'}>{'Provider'}</span>

          <Combobox
            allowClear
            multiple
            onChange={value => {
              setFilters({
                ...filters,
                providers: value as number[]
              });
            }}
            options={(providersList ?? []).map(item => ({
              value: item.id,
              label: item.name
            }))}
            placeholder={'All'}
            value={filters.providers || []}
          />
        </div>
      </FormContent>

      <Actions>
        <Button color={'primary'} onClick={fixAmounts}>
          {'Fix Amounts'}
        </Button>

        <Button onClick={refetch}>{'Refresh'}</Button>
      </Actions>
    </Wrapper>
  );
}
